<div class="container">
  <div class="card">
    <h2 class="heading">Complete your application</h2>

    <span class="text">Speed up the application review by securely providing the required information.</span>
    <div class="actions">
      <button mat-flat-button
              type="submit"
              (click)="completeApplication()"
              color="primary">COMPLETE APPLICATION</button>
    </div>
  </div>
